import * as angular from 'angular';

/**
 * This directive allows us to pad numbers in an input[type=number] for display only
 * It can be used for time, version numbers, or whatever you need.
 */

export class ZeroPaddingDirective implements angular.IDirective {
    public static $name: string = 'zeroPadding';
    public require: string = 'ngModel';

    public link(scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) {
        /* We can't just format the string in $formatters because we'll get the numfmt error -- must set view value in $parsers
         * This will make the $parser run one extra time for each change, but there should be no noticeable performance impact */

        ngModel.$parsers.push((val: any) => {
            if (!val) {
                val = 0;
            }

            let valStr = val.toString();
            let defaultPad = 2;
            let padLength = attrs['zeroPadding'] || defaultPad;

            while (valStr.length < padLength) {
                valStr = '0' + valStr;
            }

            element.val(valStr);

            return parseInt(val, 10);
        });

        ngModel.$formatters.push((val: any) => {
            return parseInt(val, 10);
        });

        /* We need to run this once on init */
        let killWatcher = scope.$watch(() => ngModel.$modelValue, () => {
            angular.forEach(ngModel.$parsers, (parser: angular.IModelParser) => {
                parser(ngModel.$modelValue);
            });

            killWatcher();
        });
    }

    public static Factory() {
        let directive = () => {
            return new ZeroPaddingDirective();
        };

        directive['$inject'] = [];

        return directive;
    }
}
